/** `rider` — technical + hospitality rider items, by category. */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const rider = defineCollection({
  key: "rider",
  labelKey: "collections.rider",
  icon: "clipboard-list",
  sheetTab: "Rider",
  dedupFields: ["category", "items"],
  sort: [{ field: "category" }],
  split: "gig",
  chatHint:
    "Rider requirements by category: backline, booth/DJ gear, monitoring, lights, hospitality " +
    "(drinks, towels, dressing room). One row per category with its item list.",
  fields: {
    category: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "promoter",
      labelKey: "rider.category",
      suggestedChips: ["Booth", "Monitoring", "Backline", "Lights", "Hospitality", "Dressing room"],
      sheet: { column: "Category" },
      description: "Rider section: booth, monitoring, backline, lights, hospitality, dressing room…",
    }),
    items: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "rider.items",
      sheet: { column: "Items" },
      description: "The requirement list for this category (free text, one per line is fine).",
    }),
    status: field({
      type: z.enum(["requested", "confirmed", "partial", "refused"]).optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "rider.status",
      sheet: { column: "Status" },
      description: "Promoter confirmation status for this category.",
    }),
    notes: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "rider.notes",
      sheet: { column: "Notes" },
      description: "Negotiation notes, substitutions agreed.",
    }),
  },
});
